import { useState } from "react";
import { useTranslation } from "react-i18next";
import type { SentenceToken } from "../game/types";
import { iconKey } from "../game/types";
import { getCell } from "../data/boards";
import IconZoom from "./IconZoom";
import type { Lang } from "../i18n";

interface Props {
  tokens: SentenceToken[];
  showGloss?: boolean;
}

export default function SentenceTrack({ tokens, showGloss }: Props) {
  const { i18n, t } = useTranslation();
  const lang = (i18n.resolvedLanguage as Lang) ?? "en";
  const [zoomed, setZoomed] = useState<SentenceToken | null>(null);

  if (tokens.length === 0) {
    return <div className="sentence-track"><span className="pos">—</span></div>;
  }
  const sorted = [...tokens].sort((a, b) => a.order - b.order);
  return (
    <>
      <div className="sentence-track">
        {sorted.map((tok, i) => {
          const cell = getCell(tok.icon.board, tok.icon.col, tok.icon.row);
          const gloss = cell?.gloss?.[lang] ?? cell?.gloss?.en ?? iconKey(tok.icon);
          return (
            <button
              key={`${iconKey(tok.icon)}-${i}`}
              className={`sentence-token ${tok.frameColor}`}
              type="button"
              onClick={() => setZoomed(tok)}
              title="Click to view this icon"
            >
              <span>{tok.order}.</span>
              {showGloss ? <span>{gloss}</span> : <span>{iconKey(tok.icon)}</span>}
              <span className="pos">{t(`pos.${tok.frameColor}`)}{tok.plural ? " · pl" : ""}{tok.tense ? ` · ${t(`tense.${tok.tense}`)}` : ""}{tok.negation ? " · ¬" : ""}</span>
            </button>
          );
        })}
      </div>
      {zoomed && (
        <IconZoom
          cellRef={zoomed.icon}
          token={zoomed}
          onClose={() => setZoomed(null)}
        />
      )}
    </>
  );
}
